import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Overview } from "./admin/Overview";
import { PlansTab } from "./admin/PlanForm";
import { EnquiriesTab } from "./admin/EnquiriesTab";
import { InvestmentsTab } from "./admin/InvestmentsTab";
import { InvestorsTab } from "./admin/InvestorsTab";
import { SecurityTab } from "./admin/SecurityTab";
import { PaymentsTab } from "./admin/PaymentsTab";
import { KycTab } from "./admin/KycTab";
import { SupportTab } from "./admin/SupportTab";
import { ActivityLogTab } from "./admin/ActivityLogTab";

const TABS = [
  { key: "investments", label: "Investments" },
  { key: "kyc", label: "KYC" },
  { key: "support", label: "Support" },
  { key: "enquiries", label: "Enquiries" },
  { key: "investors", label: "Investors" },
  { key: "plans", label: "Plans" },
  { key: "payments", label: "Payment Details" },
  { key: "activity", label: "Activity Log" },
  { key: "security", label: "Security & Alerts" },
];

export default function Admin() {
  const { user } = useAuth();
  const [tab, setTab] = useState("investments");
  const [invFilter, setInvFilter] = useState("all");
  const [refreshKey, setRefreshKey] = useState(0);

  const go = (key, filter = "all") => {
    setInvFilter(filter);
    setTab(key);
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="admin-dashboard">
      <div className="grain-overlay" />
      <Navbar />
      <main className="max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-24">
        <p className="font-accent text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Admin Console</p>
        <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
          <h1 className="font-display text-4xl lg:text-5xl tracking-tighter">Control Room.</h1>
          <p className="text-xs text-white/40" data-testid="admin-signed-in-as">Signed in as {user?.email}</p>
        </div>
        <Overview onNavigate={go} refreshKey={refreshKey} />
        <div className="flex gap-8 border-b border-white/10 mb-12 overflow-x-auto" data-testid="admin-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              data-testid={`admin-tab-${t.key}`}
              onClick={() => go(t.key)}
              className={`pb-4 font-accent text-[11px] tracking-[0.25em] uppercase transition-colors border-b-2 -mb-px whitespace-nowrap ${
                tab === t.key ? "border-[#D4AF37] text-[#D4AF37]" : "border-transparent text-white/40 hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        {tab === "plans" && <PlansTab />}
        {tab === "enquiries" && <EnquiriesTab />}
        {tab === "investments" && <InvestmentsTab initialFilter={invFilter} onChanged={() => setRefreshKey((k) => k + 1)} />}
        {tab === "investors" && <InvestorsTab />}
        {tab === "security" && <SecurityTab email={user?.email} />}
        {tab === "payments" && <PaymentsTab />}
        {tab === "kyc" && <KycTab onChanged={() => setRefreshKey((k) => k + 1)} />}
        {tab === "support" && <SupportTab onChanged={() => setRefreshKey((k) => k + 1)} />}
        {tab === "activity" && <ActivityLogTab />}
      </main>
    </div>
  );
}
